import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnChanges, inject, input } from '@angular/core';
import { Observable } from 'rxjs';

import { ServerHtmlDirective } from 'ish-core/directives/server-html.directive';

import { DotCmsUveFacade } from '../../../facades/dot-cms-uve.facade';
import { BlogComment } from '../../../models/dot-cms-uve-contentlet.model';
import { DotCmsBlogAuthorComponent } from '../dot-cms-uve-blog-author/dot-cms-uve-blog-author.component';

@Component({
  selector: 'custom-dot-cms-blog-comments',
  templateUrl: './dot-cms-uve-blog-comments.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ServerHtmlDirective, DotCmsBlogAuthorComponent, DatePipe],
})
export class DotCmsBlogCommentsComponent implements OnChanges {
  dotCmsUveFacade = inject(DotCmsUveFacade);
  readonly blogComment = input<BlogComment>(undefined);
  host$: Observable<string>;
  ngOnChanges() {
    this.host$ = this.dotCmsUveFacade.getDotCmsHost$;
  }
}
